import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationExtras } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class StateServiceWrapper {
  constructor(private router: Router, private activatedRoute: ActivatedRoute/* private state: StateService */) {
  }

  go(to: string, params = {}, options?: NavigationExtras): Promise<boolean> {
    return this.router.navigate(['/' + to, params], options);
  }

  get stateParams(): any {
    return this.activatedRoute.snapshot.params;
  }

  get queryParams(): Params {
    return this.activatedRoute.snapshot.queryParams;
  }

  is(url) {
    return this.router.routerState.snapshot.url.startsWith('/' + url);
  }
}
